import React from 'react';
import { BlogPost as SharedBlogPost } from '@akyga/shared-ui/Blog';
import Main from 'layouts/Main';
import Container from 'components/Container';
import cmsClient from 'API/cmsClient';

function BlogPost() {
  return (
    <Main>
      <Container>
        <SharedBlogPost cmsClient={cmsClient} />
      </Container>
    </Main>
  );
}

export default BlogPost;
